import { useEffect } from "react";
import { Form, Typography, Card, Space } from "antd";
import { Row, Col } from "antd";
import { MetaDataSelect } from "../../../components/forms/AutoCompleteFormItem";
import {
  ClientCategoriesSelect,
  ClientsSelect,
  ClientsTariffsSelect,
} from "../../../components/forms/AutoCompleteFormItem";
import { DatePickerItem } from "../../../components/forms/FormItems";
import DaysSelectorItems from "../../../components/forms/DaysSelectorItems";
import { flatten } from "flat";
import { useSelector } from "react-redux";
import ReadOnlyItem from "../../../components/forms/ReadOnlyItem";
import { FileTextOutlined } from "@ant-design/icons";

const { Title } = Typography;

const OrderDetails = (props) => {
  const { order } = props;
  const [form] = Form.useForm();
  const scopePrefix = useSelector((state) => state.user.scopePrefix);

  useEffect(() => {
    const flattenOrder = flatten(order, { safe: true });

    form.setFieldsValue(flattenOrder);
  }, [form, order]);
  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };
  const numberOfDays =
    (order["day_center_plan"]?.length || 0) > 0
      ? order?.day_center_half_day === true
        ? order["day_center_plan"].length - 0.5
        : order["day_center_plan"].length
      : 0;

  return (
    <Card
      bordered={true}
      className="order-details-card"
      style={{
        borderRadius: "8px",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
        margin: " 0",
      }}
    >
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "16px",
          }}
        >
          <FileTextOutlined
            style={{
              fontSize: "24px",
              color: "#1890ff",
              margin: "0 12px",
            }}
          />
          <Title level={4} style={{ margin: 0 }}>
            {order?.client?.name || ""}
          </Title>
        </div>

        <Form {...layout} form={form} style={{ padding: "0 24px" }}>
          <>
            <Row>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <ClientCategoriesSelect
                  name="client.category_id"
                  category="order"
                  required={true}
                  extraParams={{ scopePrefix }}
                  disabled={true}
                />
                <ClientsSelect
                  extraParams={{
                    scopePrefix: scopePrefix,
                  }}
                  name="client_id"
                  category="order"
                  disabled={true}
                />
                <MetaDataSelect
                  name="order_service_type.id"
                  category="order"
                  metadataName="order_service_types"
                  disabled={true}
                />
                <ReadOnlyItem
                  name="week_days_number"
                  content={numberOfDays}
                  category="order"
                />

                <ClientsTariffsSelect
                  name={"day_center_tariff.id"}
                  category={"order"}
                  disabled={true}
                />
                {/* <InputItem
              disabled={true}
              name="day_center_plan"
              category="order"
              number={true}
              min={1}
              max={7}
              step={1}
              precision={0}
            /> */}
                <DaysSelectorItems
                  name="day_center_plan"
                  category="order"
                  disabled={true}
                />
                <DatePickerItem
                  disabled={true}
                  name="effective_from"
                  category="order"
                />
                {order.effective_to && (
                  <DatePickerItem
                    name="effective_to"
                    category="order"
                    disabled={true}
                  />
                )}
              </Col>
            </Row>
          </>
        </Form>
      </Space>
    </Card>
  );
};

export default OrderDetails;
